"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.componentsCrm_de_de = void 0;
function componentsCrm_de_de() {
    return {
        "components.crm.contacts.detail.title": "Kontaktdetails",
        "components.crm.contacts.avatar": "Bild",
        "components.crm.contacts.firstname": "Vorname",
        "components.crm.contacts.lastname": "Nachname",
        "components.crm.contacts.email": "E-Mail",
        "components.crm.contacts.phone": "Telefon",
        "components.crm.contacts.mobile": "Mobiltelefon",
        "components.crm.contacts.birthday": "Geburtstag",
        "components.crm.contacts.address": "Private Adresse",
        "components.crm.contacts.company": "Firmenname",
        "components.crm.contacts.companyposition": "Position",
        "components.crm.contacts.companyphone": "Geschäftliche Telefonnummer",
        "components.crm.contacts.companyaddress": "Firmenadresse",
        "components.crm.contacts.deletion.title": "Kontakt löschen",
        "components.crm.contacts.deletion.message": "Wollen Sie diesen Kontakt wirklich löschen?"
    };
}
exports.componentsCrm_de_de = componentsCrm_de_de;
